// Whole days between now and an ISO timestamp, and a phrase for it.

export const daysFrom = (iso) => {
  if (!iso) { return null }
  const ms = new Date(iso).getTime() - Date.now()
  return Number.isNaN(ms) ? null : Math.ceil(ms / 86400000)
}

// "in 3 days", "today", "tomorrow", "2 days ago", "in 5 weeks"
export const relative = (days) => {
  if (days === null) { return '' }
  if (days === 0) { return 'today' }
  if (days === 1) { return 'tomorrow' }
  if (days < 0) { return `${-days} ${-days === 1 ? 'day' : 'days'} ago` }
  if (days >= 14) { const w = Math.round(days / 7); return `in ${w} weeks` }
  return `in ${days} days`
}
